/** @file Actors with a commit in the last minutes (MCP agents have no socket; their pills come from here). */
import type { CommitSummary } from '@pose2d/api/types';

/** Five minutes: an agent between two tool calls still counts as here. */
const WINDOW_MS = 300_000;

/** Distinct actors of the commits with `ts` within `windowMs` before `nowMs`, newest first. */
export function recentActors(commits: readonly CommitSummary[], nowMs: number, windowMs = WINDOW_MS): string[] {
  const out: string[] = [];
  for (let i = commits.length - 1; i >= 0; i -= 1) {
    const c = commits[i];
    if (c === undefined || nowMs - Date.parse(c.ts) > windowMs) break;
    if (!out.includes(c.actor)) out.push(c.actor);
  }
  return out;
}
